jQuery(window).load(() => {
    // Do not load drift if the property is set
    if ('DO_NOT_LOAD_IMPACT_RADIUS_EVENT' in window) {
        return;
    }
    setTimeout(() => {
        (function (a, b, c, d, e, f, g) {
            e.ire_o = c;
            e[c] = e[c] || function () {
                return (e[c].a = e[c].a || []).push(arguments);
            };
            f = d.createElement(b);
            g = d.getElementsByTagName(b)[0];
            f.async = 1;
            f.src = a;
            g.parentNode.insertBefore(f, g);
        })('//d.impactradius-event.com/A1217827-b192-40cb-bb89-9885c659f5c71.js', 'script', 'ire', document, window);
        ire('identify', { customerId: '', customerEmail: '' });
    }, 10);
});
